import { registerEventHandler } from 'reffects';
import { state } from 'reffects-store';
import { cookies, globals, http, queryParams } from 'reffects-batteries';
import { scrollTo } from 'effects/scrollTo';
import cache from 'effects/cache';
import { registerHttpCacheEvents } from 'events/cache';

function composeLegalDocumentCacheKey(documentName) {
    return `legal_document:${documentName}`;
}

export default function registerLegalDocumentEvents() {
    const cacheEvents = registerHttpCacheEvents(
        'ACCEPTED_LEGAL_DOCUMENT',
        function composeCacheKeyFromPayload({ documentName }) {
            return composeLegalDocumentCacheKey(documentName);
        },
        function prepareHttpGetEffectFromPayload({ documentName }) {
            return {
                url: `/api/users/current/legal-documents/${documentName}/`,
            };
        },
        function parseItemFromHttpResponse({ data: [legalDocument] }) {
            return legalDocument;
        },
        function retrievedItemHandler(legalDocument) {
            const { content, acceptedAt, locale, name } = legalDocument;
            return state.set({
                [`legalDocuments.${name}`]: legalDocument,
                legalDocumentContent: content,
                legalDocumentAcceptedAt: acceptedAt,
                legalDocumentLocale: locale,
                legalDocumentName: name,
            });
        },
        { ttl: 24 * 3600 * 1000 } // store in cache for 24h (86400 seconds)
    );

    registerEventHandler(
        'CLEAR_ACCEPTED_LEGAL_DOCUMENTS',
        function retrieveAcceptedLegalDocument() {
            return cache.delete({
                keys: [
                    composeLegalDocumentCacheKey('cookie_policy'),
                    composeLegalDocumentCacheKey('terms_and_conditions'),
                ],
            });
        }
    );

    registerEventHandler(
        'RETRIEVE_LEGAL_DOCUMENT',
        (
            {
                globals: {
                    trovitData: { locale: currentLocale },
                },
                queryParams: { locale: queryParamLocale },
                cookie: { curLang: cookieLocale },
            },
            { documentName }
        ) => {
            const locale = currentLocale || queryParamLocale || cookieLocale;

            return {
                ...http.get({
                    url: `/api/legal-documents/${documentName}/?locale=${locale}`,
                    successEvent: ['LEGAL_DOCUMENT_LOADED'],
                    errorEvent: ['LEGAL_DOCUMENT_LOAD_FAILED'],
                }),
            };
        },
        [
            globals.get('trovitData'),
            queryParams.get(['locale']),
            cookies.get('curLang'),
        ]
    );

    registerEventHandler(
        'LEGAL_DOCUMENT_LOADED',
        ({ queryParams: { anchor } }, [{ content, locale, name }]) => ({
            ...state.set({
                legalDocumentContent: content,
                legalDocumentName: name,
                legalDocumentIsLoaded: true,
                legalDocumentLocale: locale,
            }),
            ...(anchor ? scrollTo.selector(`[name=${anchor}]`) : {}),
        }),
        [globals.get('trovitData'), queryParams.get(['anchor', 'locale'])]
    );

    registerEventHandler('LEGAL_DOCUMENT_LOAD_FAILED', () => ({}));
    return cacheEvents;
}
